<section
  id="offer-chat-section"
  class="offer-chat relative flex flex-col"
  [class.offer-chat--full-page]="isFullPage()"
  [class.loading]="isLoading()"
>
  @if (isLoading()) {
    <div class="loading-overlay flex items-center justify-center">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  <!-- Header: shown in full-page (carrier tab) AND compact (shipper accordion) -->
  <div class="chat-header flex items-center justify-between px-4 py-2">
    @if (isFullPage()) {
      <span class="chat-header-title">{{ 'bids.sidebar.chat.title' | translate }}</span>
    } @else {
      <span></span>
    }
    <button
      id="offer-chat-refresh-button"
      type="button"
      class="chat-refresh-button"
      [class.spinning]="isRefreshing()"
      [disabled]="isRefreshing()"
      (click)="refresh()"
      [title]="'bids.sidebar.chat.refresh' | translate"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div #messagesContainer id="offer-chat-messages-container" class="chat-messages flex-1 overflow-y-auto px-4 py-2">
    @if (!hasMessages()) {
      <p id="offer-chat-empty-state" class="empty-hint">{{ 'bids.sidebar.chat.empty' | translate }}</p>
    } @else {
      @for (message of messages(); track message.id) {
        <div class="chat-row mb-3" [class.chat-row--sent]="message.isSentByCurrentUser">
          <span class="chat-avatar" [class.chat-avatar--sent]="message.isSentByCurrentUser" [title]="message.senderName">
            @if (message.senderLogo) {
              <img class="chat-avatar-img" src="{{ message.senderLogo }}" alt="{{ message.senderName }}" />
            } @else {
              {{ message.senderInitials }}
            }
          </span>

          <div class="chat-bubble" [class.chat-bubble--sent]="message.isSentByCurrentUser">
            <div class="chat-meta flex items-center gap-2 flex-wrap">
              <p class="chat-sender">{{ message.senderName }}</p>
              <p class="chat-time">{{ message.createdAtLabel }}</p>
            </div>
            <p class="chat-content">{{ message.content }}</p>
          </div>
        </div>
      }
    }
  </div>

  <div class="chat-input-wrap flex items-center gap-2 px-4 py-3">
    <input
      #chatInput
      id="offer-chat-input"
      type="text"
      class="chat-input"
      [value]="messageDraft()"
      [placeholder]="placeholderText()"
      (input)="onDraftInput($event)"
      (keydown.enter)="sendMessage()"
    />

    <button
      id="offer-chat-send-button"
      type="button"
      class="chat-send-button"
      [disabled]="!canSend()"
      (click)="sendMessage()"
    >
      <mat-icon>send</mat-icon>
    </button>
  </div>
</section>
